export default "__VITE_ASSET__DxXNr7Ik__"